import { TeliaCol, TeliaGrid, TeliaRow, TeliaVideoPlayer } from '@teliads/components/react';

import Breadcrumbs from 'components/custom/breadcrumbs/Breadcrumbs';
import Carousel from 'components/custom/carousel/Carousel';
import { CarouselVariant } from 'components/custom/carousel/types';
import ContentBlocksWrapper from 'components/custom/content-block/ContentBlocksWrapper';
import SEO from 'components/custom/SEO/SEO';
import SmallCard from 'components/custom/small-card/SmallCard';
import Heading from 'components/voca/heading/Heading';
import HeroBanner from 'components/voca/hero-banner/HeroBanner';
import { ArticleTemplateProps } from 'pages/Article/models';

import './ArticleTemplate.scss';

export default function ArticleTemplate({
  heroBanner,
  contentBlocks,
  carousel,
  assetLinks,
  seoMetadata,
}: ArticleTemplateProps) {
  return (
    <>
      <SEO
        title={seoMetadata.title}
        meta={seoMetadata.meta}
        socialMedia={seoMetadata.socialMedia}
      />

      <Breadcrumbs title={heroBanner.title} />

      <div className="article__hero-banner">
        <HeroBanner title={heroBanner.title} preamble={heroBanner.preamble} />
      </div>

      {heroBanner.videoUrl && (
        <TeliaGrid>
          <TeliaVideoPlayer
            controls
            slot="video"
            type="html"
            src={heroBanner.videoUrl}
            poster={heroBanner.image.url}
          />
        </TeliaGrid>
      )}

      {!!contentBlocks.length && (
        <TeliaGrid className="article__content-block-wrapper">
          <TeliaRow>
            <TeliaCol width={12}>
              <ContentBlocksWrapper contentBlocks={contentBlocks} assetLinks={assetLinks} />
            </TeliaCol>
          </TeliaRow>
        </TeliaGrid>
      )}

      {carousel.title && carousel.items.length && (
        <TeliaGrid>
          <TeliaRow>
            <TeliaCol width={12}>
              <Heading tag="h2" variant="title-100" className="article__carousel-heading">
                {carousel.title}
              </Heading>

              <div className="article__carousel-wrapper">
                <Carousel variant={CarouselVariant.SMALL}>
                  {carousel.items.map((article) => (
                    <SmallCard
                      key={article.title}
                      title={article.title}
                      category={article.category || ''}
                      url={article.slug}
                    />
                  ))}
                </Carousel>
              </div>
            </TeliaCol>
          </TeliaRow>
        </TeliaGrid>
      )}
    </>
  );
}
